<template>
  <v-container text-xs-center>
    <v-layout row wrap>
      <v-container style="min-height: 1vh;" class="scrollDesign">
        <v-layout row wrap>
          <v-flex ma-1 xs12 class="expandableContainer">
            <v-data-table
              :headers="headers"
              :rows-per-page-items="[10, 15, 25]"
              rows-per-page-text="Registros por página"
              :items="items"
              :loading="working.wPayments"
              hide-actions
              ref="table"
              item-key="id"
              no-results-text="Este pago no está divido"
              :no-data-text="working.wPayments ? 'Cargando' : (items.length > 0 ? '' : 'Este pago no está divido')"
              id="paymentsParentsTable"
            >
              <template v-slot:headers>
                <tr>
                  <th
                    class="text-xs-left"
                    style="width: 78px; max-width: 78px; min-width: 78px;"
                  >Foto</th>
                  <th
                    class="text-xs-left"
                    style="width: 280px; max-width: 280px; min-width: 280px;"
                  >Nombre</th>
                  <th
                    class="text-xs-right"
                    style="width: 120px; max-width: 120px; min-width: 120px;"
                  >Monto</th>
                  <th
                    class="text-xs-left"
                    style="width: 160px; max-width: 160px; min-width: 160px;"
                  >Estatus</th>
                </tr>
              </template>
              <template v-slot:items="props">
                <td class="text-xs-left" style="width: 78px; max-width: 78px; min-width: 78px;">
                  <v-avatar
                    :title="props.item.parent.firstName"
                    :size="avatarSize"
                    color="grey lighten-4"
                    v-if="props.item.parent.imageStorage && props.item.parent.imageStorage.miniObjUrl"
                  >
                    <img :src="props.item.parent.imageStorage.miniObjUrl" alt="avatar" />
                  </v-avatar>
                  <v-icon :size="avatarSize" v-else>account_circle</v-icon>
                </td>
                <td
                  class="text-xs-left"
                  style="width: 280px; max-width: 280px; min-width: 280px;"
                >{{ props.item.parent.firstName }} {{ props.item.parent.lastName }}</td>
                <td
                  class="text-xs-right"
                  style="width: 120px; max-width: 120px; min-width: 120px;"
                >{{ props.item.amount | formatCurrency }}</td>
                <td class="text-xs-left" style="width: 160px; max-width: 160px; min-width: 160px;">
                  <v-layout row>
                    <v-flex shrink>
                      <v-img :src="getIcon(props.item)" width="16px"></v-img>
                    </v-flex>
                    <v-flex grow>{{ props.item.status | paymentStatus }}</v-flex>
                  </v-layout>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import { funciones } from "../../../Mixins/Funciones";
export default {
  components: {},
  props: {
    user: {
      type: Object,
      required: true,
    },
    idPayment: {
      type: String,
      required: true,
    },
    idStudent: {
      type: Number,
      required: true,
    },
  },
  mixins: [funciones],
  data: () => ({
    avatarSize: "30px",
    working: {
      wPayments: false,
      wLoading: false,
    },
    items: [],
    headers: [
      {
        text: "Foto",
        align: "left",
        value: "name",
        filterItems: [],
      },
      {
        text: "Nombre",
        value: "parent.firstName",
        align: "left",
        filterItems: [],
      },
      {
        text: "Monto",
        value: "amount",
        filterItems: [],
        align: "right",
      },
      {
        text: "Estatus",
        value: "status",
        filterItems: [],
        align: "left",
      },
    ],
  }),
  watch: {
    user() {
      if (!this.user.id) return;
      this.getPaymentStudentParents();
    },
  },
  mounted() {
    if (!this.user.id) return;
    this.getPaymentStudentParents();
  },
  filters: {
    paymentStatus: function (value) {
      switch (value) {
        case "NEW":
          return "Borrador";
        case "DONE":
          return "Pendiente";
        case "PAID":
          return "Pagado";
        default:
          return "Penalizado";
      }
    },
  },
  methods: {
    getPaymentStudentParents(forceUpdate) {
      this.working.wPayments = true;
      this.$store
        .dispatch("payments/getPaymentStudentParents", {
          id: this.idPayment,
          idStudent: this.idStudent,
        })
        .then((response) => {
          this.working.wPayments = false;
          this.items = response.data.items;
          if (forceUpdate) {
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          this.working.wPayments = false;
        });
    },
    getIcon(item) {
      if (item.status === "PAID") {
        return require("@/assets/payments/payment_student_paid.png");
      }
      return require("@/assets/payments/payment_student_pending.png");
    },
  },
};
</script>

<style>
#paymentsParentsTable .v-datatable tbody {
  min-height: 1vh !important;
  max-height: auto !important;
}
</style>